module.exports = __webpack_public_path__ + "img/order-tab-cancelled-active.00a7e38b.png";